// removed by extract-text-webpack-plugin
module.exports = {"privacy-policy":"privacy-policy__2rSHk"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/views/Page/Privacy/styles.scss
// module id = ./app/scripts/views/App/views/Page/Privacy/styles.scss
// module chunks = 1